import React, { useState } from "react";
import { useRoleVerify } from "Common/RoleVerify";
import DataTable from "Common/DataTable/DataTable";
import AddItemBtn from "Common/Custom/AddItemBtn";
import FormDatePicker from "Common/Custom/ReactFlatpickr";
import useDebouncedValue from "Common/DataTable/useDebouncedValue";
import usePaginatedFetch from "Hooks/usePaginatedFetch";
import useTableConfig from "Hooks/useTableConfig";
import { generateDisplayFields } from "utils/fieldMapper";
import fields from "../../json/VehicleBookingFields.json";
import {
    getVehicleBookingsWithPagination,
    deleteVehicleBooking
} from "adminApi/TransportFacilityApi/VehicleBookingApi.js";


const VehicleBookingListTable = () => {
    const [search, setSearch] = useState("");
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [filters, setFilters] = useState({ from_date: "", to_date: "" });

    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(1);
    const debouncedSearch = useDebouncedValue(search, 500);
    const canShowAction = useRoleVerify("", ["can_edit", "can_delete"]);
    const sizeOptions = [10, 20, 50, 100];
    const { tabledata } = fields;

    // Fetch Hook
    const { data, meta, loading, error, refetch } = usePaginatedFetch(getVehicleBookingsWithPagination, {
        page,
        limit,
        search: debouncedSearch,
        from_date: filters.from_date,
        to_date: filters.to_date,
        title: "Vehicle Booking List",
        date_column: "transportation_time",
    });

    console.log("data", data)

    const displayFields = generateDisplayFields(tabledata);

    // Table Hook
    const { formattedData, columns } = useTableConfig({
        data,
        page,
        limit,
        canShowAction,
        refetch,
        isPrint: false,
        config: {
            entityName: "Vehicle Booking",
            editUrl: "edit-vehicle-booking",
            idKey: "vehicle_booking_id",
            deleteApi: deleteVehicleBooking,
            displayFields,
        },
    });

    const handleSearch = (val, resetPage = null) => {
        setSearch(val);
        if (resetPage !== null) setPage(resetPage);
    };

    const handleDateChange = (e) => {
        const { name, value } = e.target;
        if (name === "from_date") setFromDate(value);
        if (name === "to_date") setToDate(value);
    };

    const handleFilterSearch = () => {
        setFilters({ from_date: fromDate, to_date: toDate });
        setPage(1);
    };

    const handleClearFilters = () => {
        setFromDate("");
        setToDate("");
        setFilters({ from_date: "", to_date: "" });
        setPage(1);
    };

    const onPageChange = (p) => setPage(p);

    const onLimitChange = (newLimit) => {
        setLimit(newLimit);
        setPage(1);
    };

    return (
        <>

            <div className="card mb-3">
                <div className="card-header d-flex justify-content-between align-items-center">
                    <h5 className="mb-2">Search Report</h5>
                    <AddItemBtn url="create-vehicle-booking" title="Create" />
                </div>
                <div className="card-body">
                    <div className="row g-3 align-items-end">
                        <FormDatePicker
                            field={{
                                name: "from_date",
                                label: "From",
                                placeholder: "Select From Date",
                                fieldSize: "col-sm-auto col-12"
                            }}
                            value={fromDate}
                            handleChange={handleDateChange}
                        />
                        <FormDatePicker
                            field={{
                                name: "to_date",
                                label: "To",
                                placeholder: "Select To Date",
                                fieldSize: "col-sm-auto col-12"
                            }}
                            value={toDate}
                            handleChange={handleDateChange}
                        />
                        <div className="col-sm-auto col-12 d-flex gap-2">
                            <button
                                className="btn btn-success"
                                onClick={handleFilterSearch}
                            >
                                Search
                            </button>
                            <button
                                className="btn btn-outline-secondary"
                                onClick={handleClearFilters}
                            >
                                Clear
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <DataTable
                columns={columns}
                data={formattedData}
                options={{
                    loading,
                    error,
                    sortableColumns: displayFields.map((f) => f.accessor),
                    copy: true,
                    csv: true,
                    pdf: true,
                    print: true,
                    fileName: "Vehicle Booking List"
                }}
                Search={{
                    search: true,
                    SearchInputValue: search,
                    handleSearch: handleSearch,
                }}
                Entries={{
                    Entries: true,
                    limit,
                    onLimitChange,
                    options: sizeOptions,
                }}
                pagination={{
                    isActive: true,
                    meta,
                    onPageChange,
                }}
            />
        </>
    );
};

export default VehicleBookingListTable;
